import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import "core-js/modules/es.function.name.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { var _context; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'UADraftApplications' store object.
 *
 * @namespace DraftApplicationsSelectors
 */
var selectors = /*#__PURE__*/_createClass(function selectors() {
  _classCallCheck(this, selectors);
});
/**
 * @private
 */
_defineProperty(selectors, "moduleIdentifier", 'UADraftApplications');
/**
 * Retrieves the 'UADraftApplications' store object from the store.
 *
 * @param {Object} state The initial state for the reducer.
 * @returns {*} The draft applications UADraftApplications data from the store.
 *
 * @function
 * @static
 * @memberof DraftApplicationsSelectors
 */
_defineProperty(selectors, "featureState", function (state) {
  return state[selectors.moduleIdentifier];
});
/**
 * Retrieves the draft application data from the store.
 *
 * @param {Object} state The initial state for the reducer.
 * @returns {*} The draft application data from the store.
 *
 * @function
 * @static
 * @memberof DraftApplicationsSelectors
 */
_defineProperty(selectors, "selectData", function (state) {
  return selectors.featureState(state).data.payload;
});
/**
 * Retrieves the status of fetching the draft applications from the store.
 * @param {Object} state The initial state for the reducer.
 * @returns {*} The status of the request for data applications data from the server.
 *
 * @function
 * @static
 * @memberof DraftApplicationsSelectors
 */
_defineProperty(selectors, "isProcessing", function (state) {
  return selectors.featureState(state).isProcessing.payload;
});
/**
 * Retrieves the error associated with updating the store draft application details.
 * @param {Object} state The initial state for the reducer.
 * @returns {*} The error object if there was an error when requesting the draft
 * applications data from the server.
 *
 * @function
 * @static
 * @memberof DraftApplicationsSelectors
 */
_defineProperty(selectors, "selectError", function (state) {
  return selectors.featureState(state).error.payload;
});
/**
 * Order the draft applications by most recently updated.
 *
 * @param {Object} application The first application details for comparison.
 * @param {Object} otherApplication The second application details for comparison.
 * @returns {Object} The latest application based on its lastUpdatedOn date.
 * @function
 * @static
 * @memberof DraftApplicationsSelectors
 */
_defineProperty(selectors, "sortByMostRecentlyUpdated", function (application, otherApplication) {
  var applicationDate = new Date(application.lastUpdatedOn);
  var otherApplicationDate = new Date(otherApplication.lastUpdatedOn);
  return applicationDate < otherApplicationDate ? 1 : -1;
});
/**
 * Retrieve the list of all draft applications stored in Redux store and
 * sorts them by most recently updated.
 *
 * @param {Object} state The initial state for the selector.
 * @returns {*} The sorted list of draft applications by most recent updated.
 *
 * @function
 * @static
 * @memberof DraftApplicationsSelectors
 */
_defineProperty(selectors, "getFullDraftApplicationList", function (state) {
  var draftApplicationsDetailsList = [];
  var completeDraftApplicationsList = selectors.selectData(state);
  if (completeDraftApplicationsList && completeDraftApplicationsList.length > 0) {
    var _iterator = _createForOfIteratorHelper(completeDraftApplicationsList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var currentDraftApplication = _step.value;
        if (currentDraftApplication.name !== '') {
          draftApplicationsDetailsList.push(currentDraftApplication);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  if (draftApplicationsDetailsList.length > 0) {
    _sortInstanceProperty(draftApplicationsDetailsList).call(draftApplicationsDetailsList, selectors.sortByMostRecentlyUpdated);
  }
  return draftApplicationsDetailsList;
});
/**
 * This function filters a list of draft applications by the draft application parameter
 * identifier.
 * @param {*} draftApplicationId The draft application identifier the filter is based.
 * @param {*} draftApplicationsList The draft applications list to filter.
 * @returns {Object} The draftApplication if found, otherwise a null value.
 *
 * @function
 * @static
 * @memberof DraftApplicationsSelectors
 */
_defineProperty(selectors, "filterDraftApplicationByApplicationId", function (draftApplicationId, draftApplicationsList) {
  var matches = [];
  if (draftApplicationsList) {
    matches = _filterInstanceProperty(draftApplicationsList).call(draftApplicationsList, function (application) {
      return application.draft_application_id === draftApplicationId;
    });
  }
  return matches.length > 0 ? matches[0] : null;
});
/**
 * This function filters and sorts a list of draft applications by the list of types passed
 * in and last updated on.
 *
 * @param {Array} completeDraftApplicationList The list of application types.
 * @returns {array} The draft applications list sorted by the last updated.
 *
 * @function
 * @static
 * @memberof DraftApplicationsSelectors
 */
_defineProperty(selectors, "reducedApplicationList", function (completeDraftApplicationList) {
  var accumulatedDraftApplicationList = [];
  if (completeDraftApplicationList !== null && completeDraftApplicationList !== undefined) {
    if (completeDraftApplicationList.length > 0) {
      _sortInstanceProperty(completeDraftApplicationList).call(completeDraftApplicationList, function (l, r) {
        return l.lastUpdatedOn > r.lastUpdatedOn ? -1 : 1;
      });
    }
    return completeDraftApplicationList;
  }
  return accumulatedDraftApplicationList;
});
/**
 * Order the draft applications by most recent updated.
 *
 * @param {Object} leftDraftApplication The first draft application details for comparison.
 * @param {Object} rightDraftApplication The second draft application details for comparison.
 * @returns {Object} The most recent draft application based on last updated.
 *
 * @function
 * @static
 * @memberof DraftApplicationsSelectors
 */
_defineProperty(selectors, "sortedByDateSelector", function (leftDraftApplication, rightDraftApplication) {
  return leftDraftApplication.lastUpdatedOn > rightDraftApplication.lastUpdatedOn ? -1 : 1;
});
/**
 * Retrieves the draft applications for the dashboard page alerts.
 *
 * @param {Array} completeDraftApplicationList An empty list to hold draft applications
 * @returns {array} The list of draft applications.
 *
 * @function
 * @static
 * @memberof DraftApplicationsSelectors
 */
_defineProperty(selectors, "draftApplicationPodReducerSelector", function (completeDraftApplicationList) {
  return selectors.reducedApplicationList(completeDraftApplicationList);
});
export { selectors as default };